"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _js = require("@adeira/js");
var _useWithMediaQuery = _interopRequireDefault(require("../../../services/utils/useWithMediaQuery"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const displayClasses = {
  mediumMobile: {
    block: "mm:block",
    inline: "mm:inline",
    "inline-block": "mm:inline-block",
    flex: "mm:flex"
  },
  largeMobile: {
    block: "lm:block",
    inline: "lm:inline",
    "inline-block": "lm:inline-block",
    flex: "lm:flex"
  },
  tablet: {
    block: "tb:block",
    inline: "tb:inline",
    "inline-block": "tb:inline-block",
    flex: "tb:flex"
  },
  desktop: {
    block: "de:block",
    inline: "de:inline",
    "inline-block": "de:inline-block",
    flex: "de:flex"
  },
  largeDesktop: {
    block: "ld:block",
    inline: "ld:inline",
    "inline-block": "ld:inline-block",
    flex: "ld:flex"
  }
};
const hiddenClasses = {
  mediumMobile: {
    block: "block mm:hidden",
    inline: "inline mm:hidden",
    "inline-block": "inline-block mm:hidden",
    flex: "flex mm:hidden"
  },
  largeMobile: {
    block: "block lm:hidden",
    inline: "inline lm:hidden",
    "inline-block": "inline-block lm:hidden",
    flex: "flex lm:hidden"
  },
  tablet: {
    block: "block tb:hidden",
    inline: "inline tb:hidden",
    "inline-block": "inline-block tb:hidden",
    flex: "flex tb:hidden"
  },
  desktop: {
    block: "block de:hidden",
    inline: "inline de:hidden",
    "inline-block": "inline-block de:hidden",
    flex: "flex de:hidden"
  },
  largeDesktop: {
    block: "block ld:hidden",
    inline: "inline ld:hidden",
    "inline-block": "inline-block ld:hidden",
    flex: "flex ld:hidden"
  }
};
const Media = _ref => {
  var _ref2;
  let {
    displayValue = "block",
    children,
    greaterThanOrEqual,
    lessThan,
    dataTest
  } = _ref;
  const [shouldDisplay, setShouldDisplay] = React.useState(true);
  // Fallback to keep ts happy;
  const breakpoint = (_ref2 = greaterThanOrEqual !== null && greaterThanOrEqual !== void 0 ? greaterThanOrEqual : lessThan) !== null && _ref2 !== void 0 ? _ref2 : "tablet";
  process.env.NODE_ENV !== "production" ? (0, _js.warning)(!(greaterThanOrEqual == null && lessThan == null), "You should provide either greaterThanOrEqual or lessThan") : void 0;
  const callback = React.useCallback(matches => {
    if (greaterThanOrEqual != null) {
      setShouldDisplay(matches);
    } else if (lessThan != null) {
      setShouldDisplay(!matches);
    }
  }, [greaterThanOrEqual, lessThan]);
  (0, _useWithMediaQuery.default)({
    breakpoint,
    callback
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _clsx.default)(greaterThanOrEqual != null && ["hidden", displayClasses[greaterThanOrEqual][displayValue]], lessThan != null && hiddenClasses[lessThan][displayValue]),
    "data-test": dataTest,
    children: shouldDisplay ? children : null
  });
};
var _default = exports.default = Media;